import React, { createContext, useContext, ReactNode } from 'react';
import { useDeviceDetection } from '../hooks/useDeviceDetection';

type DeviceContextType = {
  deviceType: 'mobile' | 'tablet' | 'desktop';
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  needsStepByStepInterface: boolean;
  setForceDeviceType: (type: 'mobile' | 'tablet' | 'desktop', persist?: boolean) => void;
};

const DeviceContext = createContext<DeviceContextType | undefined>(undefined);

export const DeviceProvider: React.FC<{children: ReactNode}> = ({ children }) => {
  const deviceDetection = useDeviceDetection();
  
  return (
    <DeviceContext.Provider value={deviceDetection}>
      {children}
    </DeviceContext.Provider>
  );
};

export const useDevice = (): DeviceContextType => {
  const context = useContext(DeviceContext);
  if (context === undefined) {
    throw new Error('useDevice debe ser usado dentro de un DeviceProvider');
  }
  return context;
};
